import request from '@/utils/request'
/**
 * 获取api列表数据
 */
export const getApiLists = (data) => {
    return request({
        url: '/openapi/lists',
        params: data
    })
}
/**
 * 获取api选项列表数据
 */
export const getApiOptionLists = (data) => {
    return request({
        url: '/openapi/option/lists',
        params: data
    })
}
/**
 * 新增api
 */
export const addApi = (data) => {
    return request({
        url: '/openapi/manage',
        method: 'POST',
        data
    })
}
/**
 * 编辑api
 */
export const putApi = (data) => {
    return request({
        url: '/openapi/manage',
        method: 'PUT',
        data
    })
}

/**
 * api-单条详情
 */
export const getApiDetail = (id) => {
    return request({
        url: `/openapi/${id}`
    })
}

/**
 * api-删除
 */
export const delApp = (id) => {
    return request({
        url: `/openapi/${id}`,
        method: 'DELETE'
    })
}
// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/openapi/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/openapi/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/openapi/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
